/*
    Product description tables - collapse
*/
const handleEgTableCollapse = (btn, event) => {
    if (btn.classList.contains('eg-table-collapsed')) {
        btn.classList.remove('eg-table-collapsed')
        btn.setAttribute('aria-expanded', 'true')
    } else {
        btn.classList.add('eg-table-collapsed')
        btn.setAttribute('aria-expanded', 'false')
    }
}

document.querySelectorAll('.eg-table-collapse').forEach((tableWrapper, index) => {
    tableWrapper.insertAdjacentHTML('beforebegin', `
        <button class="eg-table-button eg-table-collapsed button button--secondary" type="button" aria-expanded="false" aria-controls="eg-table-wrapper-${index}" onclick="handleEgTableCollapse(this, event)">
            ${tableWrapper.dataset.title}
        </button>
    `)

    tableWrapper.setAttribute('id', `eg-table-wrapper-${index}`)
})

/*
    YouTube embed video through modal
*/
if (document.querySelector('.eg-youtube-modal')) {
    var tag = document.createElement('script');
    tag.src = "https://www.youtube.com/iframe_api";
    var firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);
}

document.querySelectorAll('.eg-youtube-modal').forEach((element, index) => {
    element.insertAdjacentHTML('beforebegin', `
        <a href="#eg-youtube-modal-${index}" data-bs-toggle="modal" data-bs-target="" class="eg-youtube-modal-link">
            <img src="http://i3.ytimg.com/vi/${element.dataset.videoId}/hqdefault.jpg" alt="Youtube video" class="" style="width: 100%">
        </a>
        <div id="eg-youtube-modal-${index}" class="modal fade" tabindex="-1" aria-labelledby="eg-youtube-modal-${index}-label" aria-hidden="true">
            <div class="modal-dialog modal-dialog-centered modal-xl">
                <div class="modal-content">
                    <div class="modal-header visually-hidden p-0 border-0">
                        <h5 class="modal-title" id="eg-youtube-modal-${index}-label">
                            YouTube Video
                        </h5>
                    </div>
                    <div class="modal-body p-0">
                        <button type="button" class="btn-close btn-close-offset-top-right" data-bs-dismiss="modal" aria-label="Close"></button>
                        <div class="ratio ratio-16x9">
                            <div id="eg-youtube-modal-${index}-player" class=""></div>
                        </div
                    </div>
                </div>
            </div>
        </div>
    `)

    let player

    document.querySelector(`#eg-youtube-modal-${index}`).addEventListener('shown.bs.modal', () => {
        player = new YT.Player(document.querySelector(`#eg-youtube-modal-${index}-player`), {
            height: '100%',
            width: '100%',
            videoId: element.dataset.videoId,
            playerVars: {
                'playsinline': 1
            },
            events: {
                'onReady': onPlayerReady
            }
        });
    
        function onPlayerReady(event) {
            event.target.playVideo();
        }

        player.play()
    })

    document.querySelector(`#eg-youtube-modal-${index}`).addEventListener('hide.bs.modal', () => {
        player.pauseVideo()
    })
})